module.exports = __webpack_public_path__ + "img/56.4ce4fef6.jpg";